import axios from "axios";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import Checkbox from "../../../common/CheckBox";
import Dropdown from "..//..//..//primer/Dropdown";
import ModalInstructions from "../../../primer/POPUP-COMPONENTS/Instructions";
import {toast} from "react-toastify";
import {checkPermission, fastTable, isEmpty} from "../../../../_helpers/commonFunctions";
import {
    setImport,
    setImportFields,
    setTooltip,
    setValues,
    setValuesChecks,
} from "../../../../_reducers/settingsSlice";
import {excelOptions} from "../../../../_data/settings/doc-types";
import {banksDummyData} from "../../../../_data/dummy_banks";
import {Row} from "react-bootstrap";
import LogTable from "../../../primer/LogTable";
import {setUpdateInnerTab} from "../../../../_reducers/activitySlice";
import ReportsTemplate from "../../../common/ReportsTemplate";
import moment from "moment";
import JoyrideTour from "../../../primer/JoyrideTour/JoyrideTour";
import {useTranslation} from "../../../../hooks/useTranslation";

export const SettingsOfImport = () => {
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const company = useSelector((state) => state.COMPANY_DATA.company);
    const section = useSelector((state) => state.SETTINGS.importExport.section);
    const fields = useSelector((state) => state.SETTINGS.importExport.fields);
    const displayTemplateName = useSelector((state) => state.SETTINGS.importExport.displayTemplateName);

    const [loader, setLoader] = useState(false);
    const permissionsData = JSON.parse(localStorage.getItem("permissions"));

    const exportSectionOptions = [
        {value: "Products", label: t("SettingsImportExport.sectionProducts")},
        {value: "Product Movements", label: t("SettingsImportExport.sectionProductMovements")},
        {value: "Clients", label: t("SettingsImportExport.sectionClients")},
        {value: "Client Movements", label: t("SettingsImportExport.sectionClientMovements")},
        {value: "Supplier Movements", label: t("SettingsImportExport.sectionSupplierMovements")},
        {value: "Sales", label: t("SettingsImportExport.sectionSales")},
        {value: "Client Payments", label: t("SettingsImportExport.sectionClientPayments")},
        {value: "POS", label: t("SettingsImportExport.sectionPOS")},
        {value: "Cash Registers", label: t("SettingsImportExport.sectionCashRegisters")},
        {value: "Bank Accounts", label: t("SettingsImportExport.sectionBankAccounts")},
        {value: "Suppliers", label: t("SettingsImportExport.sectionSuppliers")},
        //{ value: "Buys", label: "Buys" },
        //{ value: "Supplier Payments", label: "Supplier Payments" },
        {value: "Employees", label: t("SettingsImportExport.sectionEmployees")},
        {value: "Accounting Accounts", label: t("SettingsImportExport.sectionAccountingAccounts")},
        {value: "Accounting Records", label: t("SettingsImportExport.sectionAccountingRecords")},
        {value: "Fixed Assets", label: t("SettingsImportExport.sectionFixedAssets")},
        {value: "Fixed Asset Movements", label: t("SettingsImportExport.sectionFixedAssetMovements")},
    ]
    const fieldsToCheck = [
        "myDataIncExp",
        "myDataRowType",
        "myDataRowCategory",
        "myDataRowInvoiceType",
        "myDataRowVatExpenseType",
        "contactAcceptNotifications",
        "contactNotes",
        "contactEmail",
        "contactLandline",
        "contactPhone2",
        "contactPhone",
        "contactName",
        "installationCustomVat",
        "installationVatReason",
        "installationVatCategory",
        "installationPostalCode",
        "installationCity",
        "installationDOY",
        "installationAddress",
        "installationNo",
        "chequeFirstDate",
        "chequeLastDate",
        "myDataUID",
        "myDataMark",
        "extraDataTaxType",
        "extraDataTaxCode",
        "extraDataTaxAmount",
        "isTaxLine",
        "productExtraTaxType",
        "productExtraTaxCode",
        "productExtraTaxAmount",
        "deliveryLocationAddress",
        "deliveryLocationCity",
        "deliveryLocationCountry",
        "deliveryLocationPostalCode",
    ];
    const handleOnChange = (e, type = "default", ddname = "", index) => {
        //let name = "";
        let value = "";
        if (type === "dd") {
            //name = ddname;
            value = e.value;
        } else {
            //name = e.target.name;
            value = e.target.value;
        }
        if (ddname === "section") {
            dispatch(setImport(value));
        } else {
            if (type === "dd") {
                const isUnique = fields.every(
                    (obj) => obj["column"] !== value
                );
                if (!isUnique) {
                    toast.error(t("SettingsImportExport.toasts.alreadySelectedColumn"));
                } else {
                    dispatch(setValues({type, value, index}));
                }
            } else if (type === "cb" || type === "checkAll") { // Checkbox
                if ((ddname === "Delivery Location Address" || ddname === "Delivery Location City"
                        || ddname === "Delivery Location Country" || ddname === "Delivery Location Postal Code")
                    && fields.filter((el) => el.fieldKey === "deliveryLocation")[0].checkBox === false
                    && section === "Sales") {
                    toast.error(t("SettingsImportExport.toasts.deliveryLocationCheck"));
                } else if (ddname === "My Data Auth Code"
                    && fields.filter((el) => el.fieldKey === "myDataMark")[0].checkBox === false
                    && section === "Sales") {
                    toast.error(t("SettingsImportExport.toasts.myDataCheck"));
                } else {
                    dispatch(setValues({type, value, index}));
                }
            }
        }
    };

    const startImport = () => {
        setLoader(true);
        let bug = false;
        fields.forEach((element) => {
            if (element.checkBox) {
                if (isEmpty(element.column)) {
                    toast.error(t("SettingsImportExport.toasts.pleaseSelectColumnFor") + " "
                        + t("SettingsImportExport." + section + "." + element["fieldKey"]));
                    bug = true;
                }
            }
        });
        setLoader(false);

        if (!bug) dispatch(setUpdateInnerTab(2));
    }

    useEffect(() => {
        loadTooltips();
    }, [section])

    const loadTooltips = () => {
        if (section === "Products") {
            axios.post(process.env.REACT_APP_API_URL2 + `/import/productsToolTipCategories`, {company: company.id}, {
                headers: {"Content-Type": "application/json"},
            }).then((response) => {
                dispatch(setTooltip({key: "category", title: "Κατηγορίες Ειδών", content: response.data.message}));
            }).catch((error) => {
                console.log(error);
            });
        } else if (section === "Product Movements") {
            axios.post(process.env.REACT_APP_API_URL2 + `/import/productMovementsToolTipDocumentTypes`, {company: company.id}, {
                headers: {"Content-Type": "application/json"},
            }).then((response) => {
                dispatch(setTooltip({key: "documentTypeName", title: "Γενικά Παραστατικά", content: response.data.message}));
            }).catch((error) => {
                console.log(error);
            });
            axios.post(process.env.REACT_APP_API_URL2 + `/import/clientPaymentsToolTipInstallations`, {company: company.id}, {
                headers: {"Content-Type": "application/json"},
            }).then((response) => {
                dispatch(setTooltip({key: "installationMasterID", title: "Εγκαταστάσεις", content: response.data.message}));
            }).catch((error) => {
                console.log(error);
            });
        } else if (section === "Client Payments") {
            axios.post(process.env.REACT_APP_API_URL2 + `/import/clientPaymentsToolTipPaymentTypes`, {company: company.id}, {
                headers: {"Content-Type": "application/json"},
            }).then((response) => {
                dispatch(setTooltip({
                    key: "paymentType",
                    title: "Τρόποι Πληρωμής",
                    content: "Πρέπει να εκχωρήσετε τον αριθμό<br/><br/>" + response.data.message
                }));
            }).catch((error) => {
                console.log(error);
            });
            axios.post(process.env.REACT_APP_API_URL2 + `/import/clientPaymentsToolTipInstallations`, {company: company.id}, {
                headers: {"Content-Type": "application/json"},
            }).then((response) => {
                dispatch(setTooltip({key: "installation", title: "Εγκαταστάσεις", content: response.data.message}));
            }).catch((error) => {
                console.log(error);
            });
            axios.post(process.env.REACT_APP_API_URL2 + `/import/clientPaymentsToolTipDocumentTypes`, {company: company.id}, {
                headers: {"Content-Type": "application/json"},
            }).then((response) => {
                dispatch(setTooltip({
                    key: "documentTypeName",
                    title: "Τύποι Παραστατικών Εισπράξεων",
                    content: response.data.message
                }));
            }).catch((error) => {
                console.log(error);
            });
        } else if (section === "Client Movements") {
            axios.post(process.env.REACT_APP_API_URL2 + `/import/clientPaymentsToolTipInstallations`, {company: company.id}, {
                headers: {"Content-Type": "application/json"},
            }).then((response) => {
                dispatch(setTooltip({
                    key: "installationMasterID",
                    title: "Εγκαταστάσεις",
                    content: response.data.message
                }))
            }).catch((error) => {
                console.log(error);
            });
            axios.post(process.env.REACT_APP_API_URL2 + `/import/clientMovementsToolTipDocumentTypes`, {company: company.id}, {
                headers: {"Content-Type": "application/json"},
            }).then((response) => {
                dispatch(setTooltip({
                    key: "documentTypeName",
                    title: "Τύποι Παραστατικών Κινήσεων",
                    content: response.data.message
                }));
            }).catch((error) => {
                console.log(error);
            });
        } else if (section === "Supplier Movements") {
            axios.post(process.env.REACT_APP_API_URL2 + `/import/clientPaymentsToolTipInstallations`, {company: company.id}, {
                headers: {"Content-Type": "application/json"},
            }).then((response) => {
                dispatch(setTooltip({
                    key: "installationMasterID",
                    title: "Εγκαταστάσεις",
                    content: response.data.message
                }))
            }).catch((error) => {
                console.log(error);
            });
            axios.post(process.env.REACT_APP_API_URL2 + `/import/supplierMovementsToolTipDocumentTypes`, {company: company.id}, {
                headers: {"Content-Type": "application/json"},
            }).then((response) => {
                dispatch(setTooltip({
                    key: "documentTypeName",
                    title: "Τύποι Παραστατικών Κινήσεων",
                    content: response.data.message
                }));
            }).catch((error) => {
                console.log(error);
            });
        } else if (section === "Sales") {
            axios.post(process.env.REACT_APP_API_URL2 + `/import/clientPaymentsToolTipInstallations`, {company: company.id}, {
                headers: {"Content-Type": "application/json"},
            }).then((response) => {
                dispatch(setTooltip({
                    key: "installationMasterID",
                    title: "Εγκαταστάσεις",
                    content: response.data.message
                }))
            }).catch((error) => {
                console.log(error);
            });
            axios.post(process.env.REACT_APP_API_URL2 + `/import/salesToolTipDocumentTypes`, {company: company.id}, {
                headers: {"Content-Type": "application/json"},
            }).then((response) => {
                dispatch(setTooltip({
                    key: "documentTypeName",
                    title: "Τύποι Παραστατικών Πωλήσεων",
                    content: response.data.message
                }));
            }).catch((error) => {
                console.log(error);
            });
            axios.post(process.env.REACT_APP_API_URL2 + `/import/clientPaymentsToolTipPaymentTypes`, {company: company.id}, {
                headers: {"Content-Type": "application/json"},
            }).then((response) => {
                dispatch(setTooltip({
                    key: "paymentType",
                    title: "Τρόποι Πληρωμής",
                    content: "Πρέπει να εκχωρήσετε τον αριθμό<br/><br/>" + response.data.message
                }));
            }).catch((error) => {
                console.log(error);
            });
            axios.post(process.env.REACT_APP_API_URL2 + `/import/salesToolTipCarNumbers`, {company: company.id}, {
                headers: {"Content-Type": "application/json"},
            }).then((response) => {
                dispatch(setTooltip({key: "carNumber", title: "Αριθμοί αυτοκινήτων", content: response.data.message}));
            }).catch((error) => {
                console.log(error);
            });
            axios.post(process.env.REACT_APP_API_URL2 + `/import/salesToolTipSendingGoods`, {company: company.id}, {
                headers: {"Content-Type": "application/json"},
            }).then((response) => {
                dispatch(setTooltip({
                    key: "wayOfSendingGoods",
                    title: "Τρόποι αποστολής εμπορευμάτων",
                    content: response.data.message
                }));
            }).catch((error) => {
                console.log(error);
            });
        } else if (section === "Bank Accounts") {
            let prepContent = "<table className='table-bordered' style='text-align: center; margin-right: auto; margin-left: auto;'><tr><th>Swift</th><th>Όνομα Τράπεζας</th></tr>";
            for (let bank in banksDummyData) {
                prepContent += "<tr>";
                prepContent += "<td>" + banksDummyData[bank].swift + "</td>"
                prepContent += "<td>" + banksDummyData[bank].name + "</td>"
                prepContent += "</tr>";
            }
            prepContent += "</table>";
            dispatch(setTooltip({key: "bankSwift", title: "Swift Τραπεζών", content: prepContent}))
        } else if (section === "Accounting Accounts") {
            axios.post(process.env.REACT_APP_API_URL2 + "/import/accountingAccountsSettings", {company: company.id}, {
                headers: {"Content-Type": "application/json"}
            }).then((response) => {
                dispatch(setTooltip({key: "category", title: "Πρότυπα Λογαριασμών", content: response.data.message}));
            }).catch((error) => {
                console.log(error);
            })
        } else if (["Fixed Assets", "Fixed Asset Movements"].includes(section)) {
            if (section === "Fixed Asset Movements") {
                axios.post(process.env.REACT_APP_API_URL2 + `/import/fixedAssetMovementsToolTipDocumentTypes`, {company: company.id}, {
                    headers: {"Content-Type": "application/json"},
                }).then((response) => {
                    dispatch(setTooltip({
                        key: "documentTypeName",
                        title: "Τύποι Παραστατικών Κινήσεων",
                        content: response.data.message,
                    }));
                }).catch((error) => {
                    console.log(error);
                });
            }
            axios.post(process.env.REACT_APP_API_URL2 + `/import/clientPaymentsToolTipInstallations`, {company: company.id}, {
                headers: { "Content-Type": "application/json" },
            }).then((response) => {
                dispatch(setTooltip({key: "installation", title: "Εγκαταστάσεις", content : response.data.message}))
            }).catch((error) => {
                console.log(error);
            });
        } else if (section === "Accounting Records") {
            axios.post(`${process.env.REACT_APP_API_URL2}/import/accountingRecordsTooltips`, {company: company.id}, {
                headers: { "Content-Type": "application/json" },
            }).then((response) => {
                if (response.data.status === "200") {
                    dispatch(setTooltip({
                        key: "installation",
                        title: "Εγκαταστάσεις",
                        content: fastTable("installations", ["Κωδικός", "Εγκατάσταση"], response.data.installations),
                    }));
                    dispatch(setTooltip({
                        key: "categoryName",
                        title: "Λογιστικές Κατηγορίες",
                        content: fastTable("categoryNames", ["Όνομα Κατηγορίας"], response.data.accountingCategories),
                    }));
                    dispatch(setTooltip({
                        key: "subCategoryName",
                        title: "Λογιστικές Υποκατηγορίες",
                        content: fastTable("subCatogories", ["Όνομα Υποκατηγορίας"], response.data.accountingSubCategories),
                    }));
                    dispatch(setTooltip({
                        key: "documentTypeName",
                        title: "Γενικά Παραστατικά Λογιστικής",
                        content: fastTable("documentTypeNames", ["Όνομα Γενικού Παραστατικού"], response.data.accountingDocumentTypes),
                    }));
                    dispatch(setTooltip({
                        key: "paymentTypeName",
                        title: "Τρόποι Πληρωμής",
                        content: fastTable("paymentTypeNames", ["Όνομα τρόπου πληρωμής"], response.data.paymentTypes),
                    }));
                }
            }).catch((error) => {
                console.log(error);
            });
        }
    }

    const handleFinalFields = (requestFields) => {
        const clonedFields = structuredClone(fields.map(({ tooltip, ...rest }) => rest));
        const map = new Map(requestFields.map((obj) => [obj["fieldKey"], obj]));
        return clonedFields.map((obj) => {
            if (map.has(obj["fieldKey"])) {
                const updates = map.get(obj["fieldKey"]);
                return {
                    ...obj,
                    column: updates.column,
                    checkBox: updates.checkBox
                };
            }
            return obj;
        });
    };

    const [startTour1, setStartTour1] = useState(false);
    const [startTour2, setStartTour2] = useState(false);

    const tour1Steps = [
        {
            target: '.sectionDropdown',
            content: t("SettingsImportExport.joyride.section"),
            disableBeacon: true,
            disableScrolling: true,
            disableScrollParentFix: true
        },
    ];

    const tour2Steps = [
        {
            target: '.forJoyReqField',
            content: t("SettingsImportExport.joyride.fields"),
            disableBeacon: true,
            disableScrolling: true,
            disableScrollParentFix: true
        },
        {
            target: '.forJoyReqColumn',
            content: t("SettingsImportExport.joyride.columns"),
            disableScrolling: true,
            disableScrollParentFix: true
        },
        {
            target: '.forJoyTooltip',
            content: t("SettingsImportExport.joyride.tooltips"),
            disableScrolling: true,
            disableScrollParentFix: true
        },
    ];

    return (
        <>
            <div className="import-settings">
                {section && (
                    <ReportsTemplate templateType={`import_${section}`}
                                     requestData={fields.map((o) => ({...o, tooltip: null}))}
                                     setRequestData={(data) => dispatch(setImportFields(handleFinalFields(data)))}
                                     header={"Import/Export"}
                                     templateDisplayName={displayTemplateName}
                                     fetchReport={() => {}}
                    />
                )}
                {!section && (
                    <React.Fragment>
                        <button className="btn btn-primary float-right joyHelpButton" onClick={() => setStartTour1(true)}>{t("SettingsImportExport.help")}</button>
                        <JoyrideTour
                            steps={tour1Steps}
                            startTour={startTour1}
                            setStartTour={setStartTour1}
                        />
                    </React.Fragment>
                )}

                <div className="row">
                    <div className="col-12 col-md-4">
                        <Dropdown
                            label={t("SettingsImportExport.section")}
                            options={exportSectionOptions}
                            classes="sectionDropdown"
                            value={exportSectionOptions.filter((el) => el.value === section)}
                            name="section"
                            enabledValue={true}
                            onChange={(e) => handleOnChange(e, "dd", "section")}
                        />
                    </div>
                </div>
                {section && (
                    <>
                        <hr/>
                        <button className="btn btn-primary float-right joyHelpButton" onClick={() => setStartTour2(true)}>{t("SettingsImportExport.help")}</button>
                        <JoyrideTour
                            steps={tour2Steps}
                            startTour={startTour2}
                            setStartTour={setStartTour2}
                        />
                        <div className="row">
                            <div className="col-12 col-md-3">
                                <label className="w-100">
                                    <strong>{t("SettingsImportExport.fieldName")}</strong>
                                </label>
                            </div>
                            <div className="col-12 col-md-3">
                                <label className="w-100">
                                    <strong>{t("SettingsImportExport.excelColumn")}</strong>
                                </label>
                            </div>
                            <div className="col-12 col-md-3">
                                <label className="w-100">
                                    <strong>{t("SettingsImportExport.fieldName")}</strong>
                                </label>
                            </div>
                            <div className="col-12 col-md-3">
                                <label className="w-100">
                                    <strong>{t("SettingsImportExport.excelColumn")}</strong>
                                </label>
                            </div>
                            <div className="row">
                                {fields.map((field, i) => {
                                    return (
                                        <>
                                            {section === "Sales" && field.fieldKey === "documentTypeName" &&
                                                <>
                                                    <div
                                                        className="text-muted">{t("SettingsImportExport.Sales.mutedBasicData")}</div>
                                                </>
                                            }
                                            {section === "Sales" && field.fieldKey === "productName" &&
                                                <>
                                                    <hr/>
                                                    <div
                                                        className="text-muted">{t("SettingsImportExport.Sales.mutedBasicDataLine")}</div>
                                                </>
                                            }
                                            {section === "Sales" && field.fieldKey === "myDataUID" &&
                                                <>
                                                    <hr/>
                                                    <div
                                                        className="text-muted">{t("SettingsImportExport.Sales.mutedMyData")}</div>
                                                </>
                                            }
                                            {section === "Sales" && field.fieldKey === "extraDataTaxType" &&
                                                <>
                                                    <hr/>
                                                    <div
                                                        className="text-muted">{t("SettingsImportExport.Sales.mutedExtraData")}</div>
                                                </>
                                            }
                                            {section === "Accounting Accounts" && field.fieldKey === "fee" &&
                                                <>
                                                    <hr/>
                                                    <div
                                                        className="text-muted">{t("SettingsImportExport.Accounting Accounts.mutedCaseTax")}</div>
                                                </>
                                            }
                                            <div className="col-12 col-md-3 forJoyReqField">
                                                <Checkbox
                                                    text={t("SettingsImportExport." + section + "." + field["fieldKey"])}
                                                    required={field["required"]}
                                                    checked={field["checkBox"]}
                                                    defaultValue={field["checkBox"]}
                                                    value={field["checkBox"]}
                                                    disabled={field["disabled"]}
                                                    className="mb-1 mr-2 centered-checkbox"
                                                    onChange={(e) => {
                                                        if (fieldsToCheck.includes(field["fieldKey"])) {
                                                            handleOnChange(e, "checkAll", field["fieldName"], i);
                                                        } else {
                                                            handleOnChange(e, "cb", field["fieldName"], i);
                                                        }
                                                    }
                                                    }
                                                />
                                            </div>
                                            <div className="col-12 col-md-3">
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                    }}
                                                >
                                                    <div className="col-md-8 forJoyReqColumn">
                                                        <Dropdown
                                                            options={excelOptions.filter((el) => el.value.length === 0 || fields.every((obj) => obj.column !== el.value))}
                                                            disabled={!field["checkBox"]}
                                                            value={excelOptions.find((option) => {
                                                                return option.value === field["column"];
                                                            })}
                                                            onChange={(e) =>
                                                                handleOnChange(e, "dd", field["fieldName"], i)
                                                            }
                                                            enabledValue={true}
                                                        />
                                                    </div>
                                                    <div className="col-md-4">
                                                        {field["tooltip"] && (
                                                            <div className="forJoyTooltip" style={{width: '35%'}}>
                                                                <ModalInstructions data={field["tooltip"]}/>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    );
                                })}
                            </div>
                        </div>
                    </>
                )}
                <hr/>
                <div className="row">
                    <div className="text-muted">{t("SettingsImportExport.mandatoryFields")}</div>

                    {section && checkPermission("settings-importexport/import-write", permissionsData) && (
                        <div className="col-12 ml-auto mb-3">
                            <button
                                type="button"
                                className="btn btn-primary float-right"
                                onClick={() => startImport()}
                            >
                                {t("SettingsImportExport.startImport")}
                                <span> </span>
                                {loader && (
                                    <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                )}
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}

export const SettingsImport = () => {
    const SETTINGS = useSelector((state) => state.SETTINGS);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({});
    const [response, setResponse] = useState(null);
    const [checkDisabled, setCheckDisabled] = useState(false);
    const [insertDisabled, setInsertDisabled] = useState(true);
    const [loader, setLoader] = useState(false);
    const [loader2, setLoader2] = useState(false);
    const permissionsData = JSON.parse(localStorage.getItem("permissions"));
    const {t} = useTranslation();
    const [templateOptions, setTemplateOptions] = useState([]);
    const apiURL2 = process.env.REACT_APP_API_URL2;

    const section = useSelector((state) => state.SETTINGS.importExport.section);
    const fields = useSelector((state) => state.SETTINGS.importExport.fields);
    const insertNew = useSelector((state) => state.SETTINGS.importExport.insertNew);
    const updateExisting = useSelector((state) => state.SETTINGS.importExport.updateExisting);
    const firstLine = useSelector((state) => state.SETTINGS.importExport.firstLine);
    const checkData = useSelector((state) => state.SETTINGS.importExport.checkData);

    useEffect(() => {
        if (!section) {
            toast.error(t("SettingsImportExport.toasts.selectionEmpty"));
            dispatch(setUpdateInnerTab(1));
        }

        if (section) {
            let willReturn = false;
            fields.forEach((element) => {
                if (element.checkBox) {
                    if (isEmpty(element.column)) {
                        willReturn = true;
                    }
                }
            });
            if (willReturn) {
                toast.error(t("SettingsImportExport.toasts.someExcelColumnsAreEmpty"));
                dispatch(setUpdateInnerTab(1));
            }
        }
    }, [])

    const handleOnChange = (e, type = "default", ddname = "") => {
        let name = "";
        let value = "";

        if (type === "dd") {
            name = ddname;
            value = e.value;
        } else if (type === "file") {
            const selected = e.target.files[0];
            setFormData({...formData, file: selected});
        } else if (type === "cb") {
            if (ddname === "insertNew") {
                value = !insertNew;
                name = e.target.name;
            }
            if (ddname === "updateExisting") {
                value = !updateExisting;
                name = e.target.name;
            }
            name = ddname;
            dispatch(setValuesChecks({type, name, value}));
        } else {
            name = ddname;
            value = e.target.value;
            dispatch(setValuesChecks({type, name, value}));
        }
        if (checkDisabled) setCheckDisabled(false);
    }

    const errorList =
        response && response.errors && response.errors.length > 0 ? (
            response.errors.map((error, index) => (
                <p className="text-danger" key={index}>
                    {error}
                </p>
            ))
        ) : (
            <p className="text-success">No error found</p>
        );

    const backtoPrevious = () => {
        dispatch(setUpdateInnerTab(1));
    }

    const fetchTemplates = () => {
        const data = {company: company.id, type: `import_${section}`};
        axios.post(apiURL2 + `/category/list-product-template`, data, {
            headers: {"Content-Type": "application/json"}
        }).then((res) => {
            if (res.data && res.data.status === "200") {
                setTemplateOptions(res.data.data);
            } else {
                toast.error(res.data.errors);
            }
        }).catch((error) => {
            console.log(error);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const postTemplate = async (data) => {
        await axios.post(apiURL2 + `/category/add-product-template`, data, {
            headers: {"Content-Type": "application/json"},
        }).then((res) => {
            if (res.data && res.data.status === "200") {
                toast.success("New autogenerated template added.");
            } else {
                toast.error(res.data.error);
            }
        }).catch((error) => {
            if (error && error.response && error.response.data && error.response.data.errors) {
                toast.error(error.response.data.errors);
            } else {
                console.log("Unable to add template.");
            }
        })
    }

    const deleteTemplate = async (data) => {
        const deleteRequest = {id: data._id, isActive: "delete", deleted: true, deleted_at: new Date()};
        await axios.put(apiURL2 + `/category/update-product-template`, deleteRequest, {
            headers: {"Content-Type": "application/json"}
        }).then((res) => {
            if (res.data && res.data.status === "200") {
                console.log("Template deleted.");
            } else {
                toast.error(res.data.error);
            }
        }).catch((error) => {
            toast.error(error + " Update Template");
        })
    }

    const checkInsertData = (dataType, name) => {
        let bug = false;

        if (name === "insertData") {
            setInsertDisabled(true);
        } else if (name === "checkData") {
            setCheckDisabled(true);
        }
        if (!formData.file) {
            bug = true;
            toast.error(t("SettingsImportExport.toasts.pleaseSelectAFileFirst"));
        }
        if (formData.file) {
            const allowedExtensions = ["xls", "xlsx"];
            const fileExtension = formData.file.name.split(".").pop().toLowerCase();
            if (!allowedExtensions.includes(fileExtension)) {
                bug = true;
                toast.error(t("SettingsImportExport.toasts.onlyXLSXValid"));
            }
        }

        if (firstLine === undefined || firstLine === null || firstLine === "") {
            bug = true;
            toast.error(t("SettingsImportExport.toasts.firstLineIsEmpty"));
        }

        if (checkData === false && name === "insertData") {
            toast.error(t("SettingsImportExport.toasts.pleaseCheckData"));
            bug = true;
        }
        if (name === "checkData" && !checkData) {
            dispatch(setValuesChecks({type: "cb", name: "checkData", value: true}));
        }
        const importExport = SETTINGS.importExport;

        if (!importExport.insertNew && !importExport.updateExisting) {
            toast.error(t("SettingsImportExport.toasts.atLeastOneCheckbox"));
            bug = true;
        }
        if (bug === false) {
            if (dataType) {
                setLoader2(true);
            } else {
                setLoader(true);
            }

            const object = {
                company: company.id,
                year: company.year,
                section: importExport.section,
                insertNew: importExport.insertNew,
                updateExisting: importExport.updateExisting,
                insertData: dataType,
                firstLine: importExport.firstLine,
                userid: JSON.parse(localStorage.getItem("user"))._id,
            };
            const filteredArray = SETTINGS.importExport.fields.filter(
                (obj) => obj.checkBox
            );
            const obj = filteredArray.reduce((acc, cur) => {
                acc[cur.fieldKey] = cur.column.toString();
                return acc;
            }, {});
            let data = new FormData();

            object.columnMapping = obj;
            data.append("file", formData.file);
            for (let key in object) {
                data.append(
                    key,
                    typeof object[key] === "string" ||
                    typeof object[key] === "number" ||
                    typeof object[key] === "boolean"
                        ? object[key] === true
                            ? 1
                            : object[key] === false
                                ? 0
                                : object[key]
                        : JSON.stringify(object[key])
                )
            }

            let endpoint = "";
            if (section === "Products") {
                endpoint = "products";
            } else if (section === "Clients") {
                endpoint = "clients";
            } else if (section === "Client Payments") {
                endpoint = "clientPayments";
            } else if (section === "Client Movements") {
                endpoint = "clientMovements";
            } else if (section === "Supplier Movements") {
                endpoint = "supplierMovements";
            } else if (section === "Sales") {
                endpoint = "sales";
            } else if (section === "POS") {
                endpoint = "pos";
            } else if (section === "Cash Registers") {
                endpoint = "cashRegisters";
            } else if (section === "Bank Accounts") {
                endpoint = "bankAccounts";
            } else if (section === "Suppliers") {
                endpoint = "suppliers";
            } else if (section === "Accounting Accounts") {
                endpoint = "accountingAccounts";
            } else if (section === "Product Movements") {
                endpoint = "productMovements";
            } else if (section === "Fixed Assets") {
                endpoint = "fixedAssets";
            } else if (section === "Fixed Asset Movements") {
                endpoint = "fixedAssetMovements";
            } else if (section === "Accounting Records") {
                endpoint = "accountingRecords";
            } else if (section === "Employees") {
                endpoint = "employees";
            }
            axios.post(process.env.REACT_APP_API_URL2 + `/import/${endpoint}`, data, {
                headers: {"Content-Type": "application/form-data"},
            }).then((response) => {
                if (response.data.status === "200") {
                    setTimeout(async() => {
                        setResponse(response.data.data);
                        toast.success(response.data.message);
                        if (response.data.data.correctLines > 0 && name === "checkData") { // Enable the Insert Data button after Successful check.
                            setInsertDisabled(false);
                        }
                        if (dataType) {
                            setLoader2(false);
                        } else {
                            setLoader(false);
                        }
                        setCheckDisabled(false);

                        if (response.data.data.totalImported > 0 || response.data.data.totalUpdated > 0 ) {
                            if (templateOptions.length === 0) return;
                            if (String(SETTINGS.importExport.displayTemplateName).length > 0) return;
                            const autoGeneratedTemplates = templateOptions.filter(item => item.autoGenerated);

                            if (autoGeneratedTemplates.length > 3) {
                                const oldest = autoGeneratedTemplates.sort(
                                    (a, b) => new Date(a.created_at) - new Date(b.created_at)
                                )[0];
                                if (oldest) {
                                     await deleteTemplate(oldest);
                                }
                            }

                            const tempData = SETTINGS.importExport.fields.filter((field) => field.checkBox === true);
                            const postRequestData = tempData.map(({ tooltip, ...rest }) => rest);
                            const postTemplateData = {
                                company: company.id,
                                name: `Import/export ${moment().format("DD/MM/YYYY HH:mm")}`,
                                type: `import_${SETTINGS.importExport.section}`,
                                isActive: "active",
                                autoGenerated: true,
                                templateData: JSON.stringify(postRequestData),
                            };

                            if (postTemplateData && Object.keys(postTemplateData).length > 0) {
                                await postTemplate(postTemplateData);
                            } else {
                                toast.error("Template data not found.");
                            }
                            fetchTemplates();
                        }
                    }, 2000);
                } else {
                    toast.error(response.data.message);
                    if (dataType) {
                        setLoader2(false);
                    } else {
                        setLoader(false);
                    }
                    setCheckDisabled(false);
                }
            }).catch((error) => {
                if (dataType) {
                    setLoader2(false);
                } else {
                    setLoader(false);
                }
                toast.error("Error, file changed. Please press back and re-upload.");
                console.error(error);
                setCheckDisabled(false);
            })
        }
    }

    useEffect(() => {
        fetchTemplates();
    }, []);

    const [startTour3, setStartTour3] = useState(false);

    const tour3Steps = [
        {
            target: '.forJoyFile',
            content: t("SettingsImportExport.joyride.file"),
            disableBeacon: true,
            disableScrolling: true,
            disableScrollParentFix: true
        },
        {
            target: '.forJoyFirstLine',
            content: t("SettingsImportExport.joyride.firstLine"),
            disableBeacon: true,
            disableScrolling: true,
            disableScrollParentFix: true
        },
        {
            target: '.forJoyInsertNew',
            content: t("SettingsImportExport.joyride.insertNew"),
            disableBeacon: true,
            disableScrolling: true,
            disableScrollParentFix: true
        },
        {
            target: '.forJoyUpdateExisting',
            content: t("SettingsImportExport.joyride.updateExisting"),
            disableBeacon: true,
            disableScrolling: true,
            disableScrollParentFix: true
        },
        {
            target: '.forJoyCheckData',
            content: t("SettingsImportExport.joyride.checkData"),
            disableBeacon: true,
            disableScrolling: true,
            disableScrollParentFix: true
        },
        {
            target: '.forJoyInsertData',
            content: t("SettingsImportExport.joyride.insertData"),
            disableBeacon: true,
            disableScrolling: true,
            disableScrollParentFix: true
        },
    ];

    return (
        <>
            <button className="btn btn-primary float-right joyHelpButton" onClick={() => setStartTour3(true)}>{t("SettingsImportExport.help")}</button>
            <JoyrideTour
                steps={tour3Steps}
                startTour={startTour3}
                setStartTour={setStartTour3}
            />
            <Row>
                <div className="mb-2 col-12 col-md-4 forJoyFile">
                    {t("SettingsImportExport.chooseFile")}
                    <input
                        type="file"
                        className="form-control"
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        onChange={(e) => handleOnChange(e, "file", "file")}
                    />
                </div>
            </Row>
            <Row>
                <div className="mb-2 col-12 col-md-4 forJoyFirstLine">
                    {t("SettingsImportExport.firstLine")}
                    <input
                        type="number"
                        className="form-control"
                        value={SETTINGS.importExport.firstLine}
                        onChange={(e) => handleOnChange(e, "input", "firstLine")}
                        required={true}
                    />
                </div>
                <div className="mb-2 col-12 col-md-4">
                    <Checkbox
                        text={t("SettingsImportExport.insertNewRecords")}
                        value={SETTINGS.importExport.insertNew}
                        defaultValue={SETTINGS.importExport.insertNew}
                        className="mb-1 mr-2 centered-checkbox forJoyInsertNew"
                        onChange={(e) => handleOnChange(e, "cb", "insertNew")}
                    />
                </div>
                <div className="mb-2 col-12 col-md-4">
                    <Checkbox
                        text={t("SettingsImportExport.updateExistingRecords")}
                        value={SETTINGS.importExport.updateExisting}
                        defaultValue={SETTINGS.importExport.updateExisting}
                        className="mb-1 mr-2 centered-checkbox forJoyUpdateExisting"
                        onChange={(e) => handleOnChange(e, "cb", "updateExisting")}
                    />
                    {["Sales", "Buys", "Client Movements", "Supplier Movements"].includes(SETTINGS.importExport.section) && (
                        <span>(*) Σε περίπτωση που έχετε πολλαπλές γραμμές σε ίδιο παραστατικό επιλέξτε την ενημέρωση δεδομένων παραπάνω.</span>
                    )}
                </div>
            </Row>
            <div className="row">
                <div className="mb-2 col-12 col-md-4">
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => backtoPrevious()}
                    >
                        {t("SettingsImportExport.back")}
                    </button>
                </div>
                <div className="mb-2 col-12 col-md-4">
                    <button
                        type="button"
                        className="btn btn-primary forJoyCheckData"
                        disabled={checkDisabled}
                        onClick={() => checkInsertData(false, "checkData")}
                    >
                        {t("SettingsImportExport.checkData")}
                        {" "}
                        {loader && (
                            <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                            ></span>
                        )}
                    </button>
                </div>
                <div className="mb-2 col-12 col-md-4">
                    {checkPermission("settings-importexport/import-write", permissionsData) &&
                        <button
                            type="button"
                            className="btn btn-primary forJoyInsertData"
                            disabled={insertDisabled}
                            onClick={() => checkInsertData(true, "insertData")}
                        >
                            {t("SettingsImportExport.insertData")}
                            {" "}
                            {loader2 && (
                                <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                            )}
                        </button>
                    }
                </div>
            </div>

            <div className="row">
                <div className="mb-2 col-12">
                    <p>Console</p>
                    <div className="bg-light w-100 border p-3">
                        {loader === true || (loader2 === true && <p>Start Import....</p>)}
                        {response !== null && (loader === false || loader2 === false) && (
                            <>
                                <p>{response.linesFound} Lines Found.</p>
                                {errorList}
                                {response && response.totalUpdated && response.totalUpdated ? (
                                    <p className="text-success">
                                        {response.totalUpdated} {SETTINGS.importExport.section}{" "}
                                        Updated if differed
                                    </p>
                                ) : (
                                    ""
                                )}

                                {response &&
                                response.totalImported &&
                                response.totalImported > 0 ? (
                                    <p className="text-success">
                                        {response.totalImported} {SETTINGS.importExport.section}{" "}
                                        Imported
                                    </p>
                                ) : (
                                    ""
                                )}

                                {response && response.otherMessages && response.otherMessages.length > 0 ? (
                                    <>
                                        {response.otherMessages.map(item => (
                                                <p className="mb-0">
                                                    {item}
                                                </p>
                                            )
                                        )}
                                    </>
                                ) : (
                                    ""
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}

export const ImportLog = () => {
    const {t} = useTranslation();

    return (
        <React.Fragment>
            <div className="text-muted mb-2"><i>{t('Logs.importLog')}</i></div>
            <LogTable fromFile={true}/>
        </React.Fragment>
    )
}
